import React, {useState} from "react";
import FilterForm from "../../../component/FilterForm/FilterForm";
import SelectInput from "../../../component/SelectInput";
import {ApiUrl} from "../../../auth/authMethods";
import TextField from "@mui/material/TextField";
import {InputLabelProps} from "../../../utils/InputLabelProps";
import {handleChangeNumber} from "../../../utils/handleChangeNumber";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../utils/handleChangeData";
import Select from "react-select";

export default function FilterDueDateChanges({filter, setFilter, setLoadData, setPage}) {

    const statusList = [
        {value: 'CRIADA', label: 'CRIADA'},
        {value: 'COBRADA', label: 'COBRADA'},
        {value: 'PAGA', label: 'PAGA'},
        {value: 'VENCIDA', label: 'VENCIDA'},
        {value: 'CANCELADA', label: 'CANCELADA'},
        {value: 'ANTECIPADA', label: 'ANTECIPADA'},
        {value: 'AGUARDANDO_QUITACAO', label: 'AGUARDANDO_QUITACAO'},
        {value: 'EM_QUITACAO', label: 'EM_QUITACAO'},
        {value: 'QUITADA', label: 'QUITADA'},
    ]

    const [lgShow, setLgShow] = useState(false);

    const [eventoId, setEventoId] = useState('');
    const [numeroLote, setNumeroLote] = useState('');
    const [parcela, setParcela] = useState('');
    const [identificador, setIdentificador] = useState('');
    const [dataVencimentoAtual, setDataVencimentoAtual] = useState('')
    const [statusParcela, setStatusParcela] = useState('')

    const [newDate, setNewDate] = useState('')
    const [oldDate, setOldDate] = useState('')
    const [username, setUsername] = useState('')

    const [eventoList, setEventoList] = useState([]);

    const handlesSubmit = (e) => {

        e.preventDefault();

        setFilter({
            ...(eventoId && {eventoId}),
            ...(numeroLote && {numeroLote}),
            ...(parcela && {parcela}),
            ...(identificador && {identificador}),
            ...(dataVencimentoAtual && {dataVencimentoAtual}),
            ...(statusParcela && {statusParcela}),
            ...(newDate && {newDate}),
            ...(oldDate && {oldDate}),
            ...(username && {username}),
        });

        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const clearFilter = () => {
        setEventoId('')
        setNumeroLote('')
        setParcela('')
        setIdentificador('')
        setStatusParcela('')
        setDataVencimentoAtual('')
        setNewDate('')
        setOldDate('')
        setUsername('')
        setFilter({});
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 0}
        >
            <SelectInput
                url={ApiUrl + '/evento/list?status=ABERTO&size=20000'}
                list={eventoList}
                set={setEventoList}
                defaultValue={eventoId}
                setObj={setEventoId}
                returnList={() => {
                    let returnList = []
                    eventoList.forEach((item) => {
                        returnList.push({value: item.id, label: `${item.nomeEvento}`})
                    })
                    return returnList
                }}
                placeholder={"Evento"}
                isClearable
                fullWidth
            />
            <TextField
                label="Número do Lote"
                className='mt-2'
                inputProps={{
                    maxLength: 90
                }}
                value={numeroLote}
                onChange={(e) => setNumeroLote(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Parcela"
                type="text"
                value={parcela}
                inputProps={{
                    minLength: 0,
                    maxLength: 3,
                }}
                onChange={(e) => handleChangeNumber(setParcela, e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <TextField
                label="Identificador"
                inputProps={{
                    maxLength: 40
                }}
                value={identificador}
                onChange={(e) => setIdentificador(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <DatePicker
                label="Data de Vencimento Atual"
                sx={{
                    width: '100%',
                    zIndex: 0
                }}
                defaultValue={dataVencimentoAtual ? dayjs(dataVencimentoAtual) : null}
                onChange={(e) => handleChangeData(e, setDataVencimentoAtual)}
                InputLabelProps={InputLabelProps}
            />
            <DatePicker
                label="Data de Antiga"
                sx={{
                    width: '100%',
                    zIndex: 0
                }}
                defaultValue={oldDate ? dayjs(oldDate) : null}
                onChange={(e) => handleChangeData(e, setOldDate)}
                InputLabelProps={InputLabelProps}
            />
            <DatePicker
                label="Data Nova"
                sx={{
                    width: '100%',
                    zIndex: 0
                }}
                defaultValue={newDate ? dayjs(newDate) : null}
                onChange={(e) => handleChangeData(e, setNewDate)}
                InputLabelProps={InputLabelProps}
            />
            <TextField
                label="Usuário"
                inputProps={{
                    maxLength: 40
                }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                InputLabelProps={InputLabelProps}
                fullWidth
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={statusList.filter(item => item.value === statusParcela)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={statusList}
                onChange={(e) => setStatusParcela(e?.value)}
                InputLabelProps={InputLabelProps}
                placeholder={'Status da parcela'}
            />
        </FilterForm>
    </>
}